import { ApiService } from "pwapi";

import {
  BROWSER_FEATURES_SET_AVIF_SUPPORTED,
  USER_SIGNATURES_FAILURE,
  USER_SIGNATURES_REQUEST,
  USER_SIGNATURES_SUCCESS,
  SYSTEM_HEARTBEAT,
  SYSTEM_FEATURE_FLAGS_FAILURE,
  SYSTEM_FEATURE_FLAGS_REQUEST,
  SYSTEM_FEATURE_FLAGS_SUCCESS,
  GET_MACRO_HELPERS_REQUEST,
  GET_MACRO_HELPERS_ERROR,
  GET_MACRO_HELPERS_SUCCESS,
  SYSTEM_DICTATION_SET_KEY,
  SYSTEM_DICTATION_SET_LOADING_PROGRESS,
  SYSTEM_DICTATION_SET_GLOBAL_STATUS,
  SYSTEM_DICTATION_SET_TEXT,
  SYSTEM_DICTATION_THROTTLED_LOADING_PROGRESS,
  SYSTEM_DICTATION_TOGGLE,
} from "../actions/constants";
import {
  AsyncSagaAction,
  AsyncSagaActionNoArgs,
  createAsyncSaga,
} from "../utils/asyncActions";

export const heartbeat = () => {
  return {
    type: SYSTEM_HEARTBEAT,
    payload: {
      index: 0,
    },
  };
};

type UserIdArg = {
  userId: number;
};

export const fetchUserSignatures = createAsyncSaga(
  USER_SIGNATURES_REQUEST,
  USER_SIGNATURES_SUCCESS,
  USER_SIGNATURES_FAILURE,
  ({ userId }) => `signatures/?user=${userId}`,
  ({ userId }: UserIdArg) =>
    ApiService.listCaseReportSignatures({ user: `${userId}` }),
  {
    retries: 2,
    retryDelay: 1000,
  }
) as AsyncSagaAction<UserIdArg>;

export const fetchFeatureFlags = createAsyncSaga(
  SYSTEM_FEATURE_FLAGS_REQUEST,
  SYSTEM_FEATURE_FLAGS_SUCCESS,
  SYSTEM_FEATURE_FLAGS_FAILURE,
  () => "feature-flags",
  () => ApiService.listAllFeatureFlags(),
  {
    retries: 2,
    retryDelay: 1000,
  }
) as AsyncSagaActionNoArgs;

export const fetchMacroCodes = createAsyncSaga(
  GET_MACRO_HELPERS_REQUEST,
  GET_MACRO_HELPERS_SUCCESS,
  GET_MACRO_HELPERS_ERROR,
  () => "macro-codes",
  () => ApiService.helpersMacroCode(),
  {
    skipDuplicates: false,
    retries: 2,
    retryDelay: 1000,
  }
) as AsyncSagaActionNoArgs;

export const setAvifSupport = (payload = true) => {
  return {
    type: BROWSER_FEATURES_SET_AVIF_SUPPORTED,
    payload,
  };
};

export const setDictationKey = (payload: string | null) => {
  return {
    type: SYSTEM_DICTATION_SET_KEY,
    payload,
  };
};

export const setDictationText = (payload: string | Array<string>) => {
  return {
    type: SYSTEM_DICTATION_SET_TEXT,
    payload,
  };
};

export const toggleDictation = (payload: boolean) => {
  return {
    type: SYSTEM_DICTATION_TOGGLE,
    payload,
  };
};

export const setDictationGlobalStatus = (payload: string) => {
  return {
    type: SYSTEM_DICTATION_SET_GLOBAL_STATUS,
    payload,
  };
};

export const setDictationLoadingProgress = (payload: number) => {
  return {
    type: SYSTEM_DICTATION_SET_LOADING_PROGRESS,
    payload,
  };
};

export const setDictationThrottledLoadingProgress = (payload: number) => {
  return {
    type: SYSTEM_DICTATION_THROTTLED_LOADING_PROGRESS,
    payload,
  };
};
